const $inject = ['$scope', '$routeParams', '$filter', 'dataService', 'timeZoneService'];

const lbaTimeZoneSelectCtrl = function ($scope, $routeParams, $filter, dataService, timeZoneService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);

  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  
  vm.selectType = vm.settings.selectType || 'multi';
  vm.refreshZones = refreshZones;

  
  function refreshZones(userSearch) {
    var zones = timeZoneService.get();

    vm.zones = $filter('filter')(zones, userSearch, false);
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  })
};

lbaTimeZoneSelectCtrl.$inject = $inject;

export default lbaTimeZoneSelectCtrl;


// WEBPACK FOOTER //
// ./src/components/lbaTimeZoneSelect/lbaTimeZoneSelectCtrl.js